// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zahz","tabsBox":"styles_tabsBox__1t5ZD","createButton":"styles_createButton__1vliW"};